import logoIA from '@assets/Logo-IA.png'
import close from '@assets/nuevos-iconos/x.png'
import { useAppStore } from '@store'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export function IA() {
  const prefs = useAppStore.use.prefs()
  const navigate = useNavigate()
  const isLogged = window.localStorage.getItem('isUserLogged')
  const openModal = useAppStore.use.openModal()

  const PREDEF_IA_01_IMAGE = prefs?.['PREDEF_IA_01_IMAGE']
  const PREDEF_IA_02_IMAGE = prefs?.['PREDEF_IA_02_IMAGE']
  const PREDEF_IA_03_IMAGE = prefs?.['PREDEF_IA_03_IMAGE']
  const PREDEF_IA_04_IMAGE = prefs?.['PREDEF_IA_04_IMAGE']
  const PREDEF_IA_05_IMAGE = prefs?.['PREDEF_IA_05_IMAGE']
  const PREDEF_IA_06_IMAGE = prefs?.['PREDEF_IA_06_IMAGE']

  const images = [
    PREDEF_IA_01_IMAGE,
    PREDEF_IA_02_IMAGE,
    PREDEF_IA_03_IMAGE,
    PREDEF_IA_04_IMAGE,
    PREDEF_IA_05_IMAGE,
    PREDEF_IA_06_IMAGE,
  ]

  const roomType = [
    'dormitorio',
    'sala de estar',
    'habitacion juvenil',
    'baño',
    'comedor',
    'cocina',
  ]

  useEffect(() => {
    if (!document.body) {
      return
    }
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        navigate('/planner')
      }
    }
    document.body.addEventListener('keydown', handleKey)
    return () => {
      document.body.removeEventListener('keydown', handleKey)
    }
  }, [])

  const handleClick2 = (tipo) => {
    navigate('/iaform', { state: tipo })
  }
  return (
    <div className='scrollable absolute left-0 top-0 h-screen w-screen overflow-y-auto overflow-x-hidden bg-C/ColorF01'>
      <div className=' absolute right-8 top-9 z-50 cursor-pointer'>
        <img
          onClick={() => {
            navigate('/planner')
          }}
          role='button'
          src={close}
          className='cursor-pointer'
        />
      </div>
      <div className='my-2 flex h-[66px] w-screen items-center justify-between bg-C/ColorF03 '>
        <img
          className='ml-16 h-12 '
          src={logoIA}
        />
        <p className=' ml-[19.35rem] text-end text-[28px] font-semibold text-C/ColorF11'>
          {'Inspira tus proyectos con IA'}
        </p>
        <div className='mr-14 flex flex-row gap-4 pr-7'>
          <div
            className=' flex h-[44px] w-[265px] cursor-pointer items-center justify-center rounded-md border bg-C/ColorF05'
            onClick={() => navigate('/planner')}
          >
            <p className='text-sm text-C/ColorF04'>{'Nuevo Diseño'}</p>
          </div>
          <div
            className=' flex h-[44px] w-[265px] cursor-pointer items-center justify-center rounded-md border bg-C/ColorF05'
            onClick={() => {
              openModal()
              if (!isLogged) {
                navigate('/planner/login')
              } else {
                navigate('/planner/proyectos')
              }
            }}
          >
            <p className='text-sm text-C/ColorF04'>{'Diseño Existente'}</p>
          </div>
        </div>
      </div>
      <div className='grid grid-flow-row grid-cols-3 self-center bg-C/ColorF01 pl-5'>
        {images.map(
          (img, id) =>
            img !== '' && (
              <div
                className=' mb-4 flex h-min w-fit flex-col '
                key={roomType[id]}
              >
                <img
                  className='h-[404px] w-[609px] cursor-pointer rounded-xl border-2 border-C/ColorF11'
                  src={img}
                  onClick={() => handleClick2(roomType[id])}
                />
              </div>
            ),
        )}
      </div>
    </div>
  )
}
